import { ComponentProps } from 'react';
import {
  AppSpinnerSize,
  appSpinnerClasses,
} from './appSpinnerClasses/appSpinnerClasses';

/**
 * The one spinner of the logged-in apps: a turning quarter ring in three sizes.
 *
 * Always indeterminate. A percentage (upload, mass send) goes on `Progress`,
 * since a turning ring can't show a fraction.
 *
 * `pathLength='100'` makes dash `25 75` a quarter ring at any radius.
 *
 * The svg is sized inline, not by class, because IconButton's `[&_svg]:size-5`
 * would otherwise enlarge it past the button.
 */
export const AppSpinner = ({
  size = 'lg',
  className,
  ...spinnerProps
}: {
  size?: AppSpinnerSize;
} & ComponentProps<'span'>) => {
  return (
    <span
      role='progressbar'
      className={appSpinnerClasses({ size, className })}
      {...spinnerProps}
    >
      {/* `block` keeps the svg off the text baseline, avoiding a descender
          gap in a button. Stated here so every app draws it the same. */}
      <svg
        viewBox='0 0 24 24'
        style={{ width: '100%', height: '100%' }}
        className='block'
      >
        <circle
          cx='12'
          cy='12'
          r='10'
          fill='none'
          pathLength='100'
          strokeLinecap='round'
          strokeWidth={3}
          strokeDasharray='25 75'
          className='stroke-current'
        />
      </svg>
    </span>
  );
};
